
import React                from 'react';
import { observer, inject } from 'mobx-react';

import { Menu                 } from './commun/Menu';
import { Bandeau              } from './commun/Bandeau';
import { CouvertureSmartphone } from './CouvertureSmartphone';

/* *********************************************************************************** */
/* **********                                                               ********** */
/* **********                             Couverture                        ********** */
/* **********                                                               ********** */
/* *********************************************************************************** */

export const Couverture = inject(['store'])(observer(class Couverture extends React.Component {

  /* ---------------------- */
  /* Affichage du composant */
  /* ---------------------- */

  render() {

    if (window.innerWidth < 1080) return <CouvertureSmartphone />;

    const largeur = this.props.store.largeurBandeau + 'px' ;

    /* ------------------------------ */
    /* Définition des CSS d'affichage */
    /* ------------------------------ */

    const styleBlocTexte = {
      width           : this.props.largeur ? this.props.largeur : "1063px",
      display         : "block",
      marginTop       : "30px",
      marginLeft      : "auto",
      marginRight     : "auto",
      marginBottom    : "10px",
      textAlign       : 'center'      
  };


    /* ----------------------------------------- */
    /* Définition de l'onglet du menu à afficher */
    /* ----------------------------------------- */

    this.props.store.definirSelectionOnglet ("couverture");

    /* ------------------------------- */
    /* Définition du titre de l'onglet */
    /* ------------------------------- */

    document.title = "Couvertures - La geste d'Aros";

    /* -------------------------------- */
    /* Formatage des données à afficher */
    /* -------------------------------- */

    /* ------------------- */
    /* Renvoi du composant */
    /* ------------------- */

    return (

        <div id='divCouverture' style={{textAlign:'center'}}> 

              <Bandeau largeur={largeur} />

              <Menu menu = {this.props.store.menu} />

              <div style={styleBlocTexte}>  

                  <p className="Recit">
                      Parmi les diverses embûches que le malheureux auteur doit déjouer pour éditer son beau roman, tel le héros accomplissant sa noble quête (je répète une fois encore : « toutes proportions gardées »), il en est une des plus redoutables que je résumerais ainsi : <b>l’image de couverture</b>.
                  </p>
                  <p className="Recit">
                      Pour celui qui n’y connais absolument rien, et qui est de plus d’une nullité crasse dès qu’il s’agit de griffonner un quelconque dessin, c’est là un obstacle majeur. Et je rentre hélas dans cette catégorie, à savoir celle des gens dénués de tout talent graphique. Cela ne m’empêche pas d’apprécier à leur juste valeur les œuvres d’artistes dignes de ce nom. Mais une fois l’image de votre choix trouvée sur internet, il reste l’épreuve de la mise en relation avec celui ou celle qui l’a réalisée. Et lorsque malgré toute votre bonne volonté et vos divers envois de mails dans un anglais douteux, car souvent à destination de l’étranger, l’artiste ne daigne même pas vous répondre, vous vous retrouvez bien embêté.
                  </p>    
                  <p className="Recit">
                      Or l’image de couverture est primordiale : grâce à elle, le futur lecteur peut en un clin d’œil déterminer s’il a envie ou non de lire l’épais volume qui se trouve derrière cette aguichante première page. Même quelqu’un qui au final n’appréciera pas le roman ne pourra que reconnaître la beauté et la qualité de l’image.
                  </p>
                  <p className="Recit">
                      La chance et le hasard m’ont fait rencontrer <b>Laura Duval</b>, qui se trouve être la fille d’un collègue de travail. On ne répétera jamais assez toute l’étendue des bienfaits de la pause café en entreprise. Une rencontre dans un restaurant japonais et une présentation succincte du roman nous ont amené à travailler ensemble, ce dont je me réjouis encore aujourd’hui.
                  </p>
                  <p className="Recit">
                      Je mets donc à votre disposition en haute résolution les superbes images réalisées par Laura. Je vous incite également à aller consulter son oeuvre sur <a href='https://www.facebook.com/pg/OraNocta/photos/?ref=page_internal' target='_blank' rel="noopener noreferrer">facebook</a> ou sur instagram : ora_nocta_ 
                  </p>

                  <div style={{display:"flex",flexDirection: "row", justifyContent: 'space-around', width:'100%', marginTop:"100px"}}>

                      <div style={{display:"inline-block"}}>
                          <a href="/aros/images/Couvertures/La geste d'Aros - Couverture Tome 1.jpg" download="La geste d'Aros - Couverture Tome 1.jpg" target='_blank'>
                              <div className="tome1reduit"></div>
                          </a>   
                      </div>

                      <div style={{display:"inline-block"}}>
                          <a href="/aros/images/Couvertures/La geste d'Aros - Couverture Tome 2.jpg" download="La geste d'Aros - Couverture Tome 2.jpg">
                              <div className="tome2reduit"></div>
                          </a>   
                      </div>

                  </div>  

             </div>

        </div>
      )
    } 
  } // Fin de la classe Couverture
))



// WEBPACK FOOTER //
// ./src/components/Couverture.js